import * as React from 'react';
type Props = {
  className?: string;
};
export function Beets({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Beets"
      className={className}
    >
      <path
        d="M21.0703 36.6896L25.9674 34.5427M29.7553 28.5121L21.6699 32.0568M14.2393 30.8973L24.0717 26.5868M28.216 21.1874L19.6985 24.9215M23.8977 1.00288L21.5445 21.0911M8.28171 11.7161L18.8989 21.9687M31.4154 24.1299C32.6542 26.8894 32.1677 30.0168 30.4219 32.4836C29.2442 34.1477 28.4448 36.0022 27.8602 37.889L27.516 39.0001L26.3442 38.4414C24.4811 37.5529 22.4429 37.0158 20.3521 36.6541C17.5499 36.1693 15.126 34.4647 13.9798 31.8501C11.711 26.675 16.5573 22.7047 22.9214 20.8344C26.3908 19.8147 30.0755 21.1452 31.4154 24.1299ZM21.8074 16.9891C18.6593 15.6474 16.4551 6.09494 17.8658 5.35655C18.9188 4.80539 19.1479 6.02386 20.1853 6.05145C21.7816 6.09387 21.2731 1.1851 23.6831 1.00532C25.0264 0.905123 25.4758 2.23272 25.4591 3.86626C25.4051 9.178 27.8663 5.07629 29.1339 6.29874C31.0396 8.13648 25.7584 16.4054 21.8074 16.9891ZM16.6347 20.0013C14.4633 21.2347 7.94443 18.2881 8.13994 17.1427C8.28591 16.2877 9.09439 16.6938 9.56934 16.104C10.3002 15.1963 7.22642 13.3199 8.18824 11.8417C8.72433 11.0178 9.69361 11.3442 10.6343 12.0766C13.693 14.4577 12.4015 11.2149 13.6716 11.02C15.5813 10.727 18.0437 17.4501 16.6347 20.0013Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
